/**
 * Determines, if the safe area fix is supported by the app's native library (in Felis >=v32.0.0, in Leopard >=v17.0.0).
 * This can be used as the condition for applying safe-area-inset CSS values.
 * Related Jira ticket: https://outfit7.atlassian.net/browse/WEB-2595.
 * Defaults to `true` so that interactive content doesn't end up in safe areas, if something goes wrong with detection.
 * @param {string} lV Library version
 * @param {string} p Platform
 * @default true
 */
export function isSafeAreaFixSupported(lV, p) {
  const DEFAULT = true
  const majorVersion = parseInt(lV.split('.')[0])
  const platform = p.toLowerCase()
  if (platform.includes('android')) return majorVersion >= 32
  if (platform.includes('iphone')) return majorVersion >= 17
  return DEFAULT
}